<template>
  <div :class="{ 'bnw-gray': blackAndWhite }">
    <template v-if="fullWidth">
      <article-content-render
        :category="category"
        :slug="slug"
        :presetDetail="presetDetail"
      ></article-content-render>
      <div class="cx-sec">
        <div class="cx-div">
          <sight-map-media
            v-bind="detail.otherMedia"
            :audio="detail.otherMedia && detail.otherMedia.audioGuide && detail.otherMedia.audioGuide.filter(a => !!a)"
            :sharePath="$route.fullPath.split('/').slice(2).join('/')"
          ></sight-map-media>
        </div>
        <sight-map-bread-crumb
          v-bind="brumbSetting"
          :category="brumbSetting.category || category"
          :entity="detail.title"
          :updatedAt="detail.updatedAt"
          isArticle
        ></sight-map-bread-crumb>
      </div>
    </template>
    <template v-else>
      <section class="cx-media--header" v-if="detail.banner">
        <div class="cx-media__img"
          :style="`background-image: url(${getMediaHost(detail.banner, 'MGTO')})`"
        ></div>
      </section>
      <section class="cx-sec">
        <div class="cx-wrap--page">
          <div class="cx-row -j-center">
            <article class="cx-col-md-9" :class="articleClasses">
              <div class="cx-div--outer">
                <h1 class="cx-t20 m-title">{{detail.title}}</h1>
                <div class="cx-t10 -fade m-subtitle" v-if="author.name">
                  <span v-if="!author.link">{{author.name}}</span>
                  <component v-else :is="''" v-bind="linkProps(author.link)"
                  >{{author.name}}</component>
                </div>
              </div>
              <slot name="content">
                <div class="cx-div -fade m-div__content">
                  <article-content-render
                    :category="category"
                    :slug="slug"
                    :presetDetail="presetDetail"
                  ></article-content-render>
                  <!--  -->
                </div>
              </slot>

              <slot name="extractContent">
              </slot>

              <div class="cx-div">
                <sight-map-media
                  v-bind="detail.otherMedia"
                  :audio="detail.otherMedia && detail.otherMedia.audioGuide && detail.otherMedia.audioGuide.filter(a => !!a)"
                  :sharePath="$route.fullPath.split('/').slice(2).join('/')"
                ></sight-map-media>
              </div>
              <sight-map-bread-crumb
                v-bind="brumbSetting"
                :category="brumbSetting.category || category"
                :entity="detail.title"
                :updatedAt="detail.updatedAt"
                isArticle
              ></sight-map-bread-crumb>
            </article>
            
            <nav class="cx-col-md-3" 
              :class="sidebarClasses"
              v-if="$slots.sidebar">
              <slot name="sidebar"></slot>
            </nav>          
          </div>
        </div>
      </section>
    </template>
    <!-- <discover-more-loader></discover-more-loader> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ArticleContentRender from '@/components/ArticleContentRender';
// import DiscoverMoreLoader from '@/components/DiscoverMoreLoader';
import SightMapBreadCrumb from '@/components/SightMapBreadCrumb';
import ShareModal from '@/components/ShareModal';
import headerUpdater from '@/mixins/headerUpdater';
import SightMapMedia from '@/components/SightMapMedia';
import SightMapView from '@/views/SightMapView';

export default {
  name: 'article-wrapper',
  mixins: [headerUpdater({ firePageLoadedEvent: true })],
  uit() {
    return [
      ['common', ['updatedAt']]
    ]
  },
  header() {
    return {
      title: this.detail.title || this.presetDetail.title,
      ogImg: this.detail.banner ? this.getMediaHost(this.detail.banner, 'MGTO') : undefined,
      desc: this.parseHtmlToShortDesc(this.detail.summary || this.detail.content)
    }
  },
  data() {
    return {
      showShareModal: false,
      hostname: '',
    }
  },
  props: {
    author: {
      type: Object,
      default: () => ({})
    },
    articleClasses: {
      type: Array,
      default: () => []
    },
    sidebarClasses: {
      type: Array,
      default: () => []
    },
    category: {
      type: String,
      default: 'article'
    },
    brumbSetting: {
      type: Object,
      default: () => ({})
    },
    slug: {
      type: String,
      default: '',
    },
    presetDetail: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ArticleContentRender,
    // DiscoverMoreLoader,
    // SightMapView,
    SightMapBreadCrumb,
    ShareModal,
    SightMapMedia
  },
  computed: {
    ...mapState({
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    config: function() {
      let config = {};

      if (typeof this.detail == 'object' 
        && typeof this.detail.script == 'string'
        && this.detail.script.length > 0
      ) {
        try {
          config = Function(
            'config',
            'injectFunc',
            'enjectFunc',
            `"use strict";
            ${this.detail.script}; 
            return config`
          ).call();
          console.log(config);
        } catch (e) {
          console.error(e);
        }
      }

      return typeof config == 'object' ? config : {};
    },
    fullWidth: function() {
      return !!this.config.fullWidth;
    },
    detail: function() {
      return this.slug ? this.$store.getters['article/getArticle'](
        this.category,
        this.slug,
        this.$i18n.locale
      ) : this.presetDetail;
    }
  },
}
</script>

<style lang="scss">
  .m-div{
    &__content{
      li{
        margin: $int-space-sm 0;
      }
      table{
        @media(max-width:767px){
          overflow-y: scroll;
          display: block;
          width: 100%;
        }
      }
    }
  }
</style>